// Demand class constants for use in Angular controllers / components.
//
// These values come from the form's `demand_class` radio button, which Rails
// renders as string-valued <input type="radio"> elements. Angular's `@`
// bindings and `$scope.demandClass` therefore receive STRINGS, so these
// constants are strings.
//
// Source of truth: app/models/demand_tag.rb (DemandTag::CLASS_*).
// Keep these values in sync if the Ruby constants ever change. They're
// integer column values, so changes are extremely rare.
const DEMAND_CLASSES = Object.freeze({
  CLASS_TAG: '1',
  CLASS_DIRECT_CONNECT: '2',
  CLASS_HEADER_BIDDING: '3',
  CLASS_CREATIVE_ASSET: '4',
  CLASS_OPEN_RTB: '5',
  CLASS_OPEN_RTB_DIRECT_CONNECT: '6',
  CLASS_OPEN_RTB_OPEN_MARKET: '7',
  CLASS_HOUSE_AD: '8',
  CLASS_SPOTX_CONNECT: '9',
  CLASS_SPOTX_CONNECT_MARKET: '10',
  CLASS_LINE_ITEM: '11',
  CLASS_MARKETPLACE_DEAL: '12',
  CLASS_DIRECT_IO_DIRECT_CONNECT: '13',
  CLASS_DIRECT_IO_LINE_ITEM: '14',
  CLASS_SUPPLY_CHANNEL: '15',
  CLASS_AD_SOURCE: '16'
});

export default DEMAND_CLASSES;
